import React from "react";
// eslint-disable-next-line no-unused-vars
import style from "./SmallContent.scss";

export const SmallContent = (props) => {
  return <div className="small-content">{props.children}</div>;
};
